enum TemporaryPricePeriodEnum {
	periodStartAndEnd = 'PeriodStartAndEnd',
	periodEnd = 'PeriodEnd',
	periodNone = 'PeriodNone'
}

export default TemporaryPricePeriodEnum;
